/* This plugin allow to declare all UI components globally */
/* Just import this file in the main.js file with Vue.use(KerlinkUI) and you're done */

// CSS
import 'vue-multiselect/dist/vue-multiselect.min.css'

// Common components > chunk klk-ui
const Avatar = () => import(/* webpackChunkName: "klk-ui" */ 'vue-kerlink/dist/components/Avatar')
const AlarmBadge = () => import(/* webpackChunkName: "klk-ui" */ './AlarmBadge')
const Card = () => import(/* webpackChunkName: "klk-ui" */ 'vue-kerlink/dist/components/Card')
const DropdownCustomItem = () => import(/* webpackChunkName: "klk-ui" */ './DropdownCustomItem')
const FloatingButton = () => import(/* webpackChunkName: "klk-ui" */ 'vue-kerlink/dist/components/FloatingButton')
const Messages = () => import(/* webpackChunkName: "klk-ui" */ './Messages')
const Nanobar = () => import(/* webpackChunkName: "klk-ui" */ './Nanobar')
const ScrollToTop = () => import(/* webpackChunkName: "klk-ui" */ 'vue-kerlink/dist/components/ScrollToTop')
const SelectGroup = () => import(/* webpackChunkName: "klk-ui" */ './SelectGroup')

// Small components > chunk klk-ui extended
const ContextMenu = () => import(/* webpackChunkName: "klk-ui-ext" */ './ContextMenu')
const Countdown = () => import(/* webpackChunkName: "klk-ui-ext" */ 'vue-kerlink/dist/components/Countdown')
const Confirm = () => import(/* webpackChunkName: "klk-ui-ext" */ 'vue-kerlink/dist/components/Confirm')
const Dropzone = () => import(/* webpackChunkName: "klk-ui-ext" */ './Dropzone')
const DropzoneAsyncBulk = () => import(/* webpackChunkName: "klk-ui-ext" */ './DropzoneAsyncBulk')
const Grid = () => import(/* webpackChunkName: "klk-ui-ext" */ './Grid')
const Modal = () => import(/* webpackChunkName: "klk-ui-ext" */ 'vue-kerlink/dist/components/Modal')
const NavTabsExtended = () => import(/* webpackChunkName: "klk-ui-ext" */ './NavTabsExtended')
const ProgressCircular = () => import(/* webpackChunkName: "klk-ui-ext" */ 'vue-kerlink/dist/components/ProgressCircular')
const Stepper = () => import(/* webpackChunkName: "klk-ui-ext" */ './Stepper')

// Form components
const Multiselect = () => import(/* webpackChunkName: "klk-ui-form" */ 'vue-multiselect')

// Big components > separate chunk
const LMapMarker = () => import(/* webpackChunkName: "klk-ui-map" */ './LMapMarker')
const LCluster = () => import(/* webpackChunkName: "klk-ui-map" */ './LCluster')
const LMap = () => import(/* webpackChunkName: "klk-ui-map" */ './LMap')
const PasswordStrength = () => import(/* webpackChunkName: "pwd-strength" */ './PasswordStrength')

const KerlinkUI = {
  install (Vue) {
    Vue.component('avatar', Avatar)
    Vue.component('alarm-badge', AlarmBadge)
    Vue.component('card', Card)
    Vue.component('dropdownCustomItem', DropdownCustomItem)
    Vue.component('floatingButton', FloatingButton)
    Vue.component('messages', Messages)
    Vue.component('nanobar', Nanobar)
    Vue.component('scrollToTop', ScrollToTop)
    Vue.component('selectGroup', SelectGroup)

    Vue.component('contextMenu', ContextMenu)
    Vue.component('countdown', Countdown)
    Vue.component('confirm', Confirm)
    Vue.component('dropzone', Dropzone)
    Vue.component('dropzoneAsyncBulk', DropzoneAsyncBulk)
    Vue.component('grid', Grid)
    Vue.component('modal', Modal)
    Vue.component('navTabsExtended', NavTabsExtended)
    Vue.component('progressCircular', ProgressCircular)
    Vue.component('stepper', Stepper)

    Vue.component('multiselect', Multiselect)

    Vue.component('l-map-marker', LMapMarker)
    Vue.component('l-cluster', LCluster)
    Vue.component('l-map', LMap)

    Vue.component('password-strength', PasswordStrength)
  }
}

export default KerlinkUI
